import dev from "./dev";
// @ts-ignore
import prod from "./prod";

export default {
  ...(process && process.env && process.env.LOCAL) ? dev : prod
}
